<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-icon class="mr-2">mdi-chart-box</v-icon>
            Capture Summary
          </v-card-title>
          
          <v-card-text>
            <v-row>
              <!-- Summary Statistics -->
              <v-col cols="12" md="3">
                <v-card variant="outlined">
                  <v-card-text class="text-center">
                    <div class="text-h3 text-primary">{{ totalTrays }}</div>
                    <div class="text-caption text-grey">Total Trays</div>
                  </v-card-text>
                </v-card>
              </v-col>
              
              <v-col cols="12" md="3">
                <v-card variant="outlined">
                  <v-card-text class="text-center">
                    <div class="text-h3 text-primary">{{ totalEggs }}</div>
                    <div class="text-caption text-grey">Total Eggs</div>
                  </v-card-text>
                </v-card>
              </v-col>
              
              <v-col cols="12" md="3">
                <v-card variant="outlined">
                  <v-card-text class="text-center">
                    <div class="text-h3 text-primary">{{ avgWeight }}</div>
                    <div class="text-caption text-grey">Avg Weight (g)</div>
                  </v-card-text>
                </v-card>
              </v-col>
              
              <v-col cols="12" md="3">
                <v-card variant="outlined">
                  <v-card-text class="text-center">
                    <div class="text-h3 text-primary">{{ avgColorDelta }}</div>
                    <div class="text-caption text-grey">Avg Color Delta</div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- Data Table -->
            <v-row class="mt-4">
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="sessionData"
                  :items-per-page="10"
                  class="elevation-1"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Captured Data</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="exportData">
                        <v-icon start>mdi-download</v-icon>
                        Export
                      </v-btn>
                    </v-toolbar>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="$router.push('/egg-vision')">
              Back to Capture
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SummaryView',
  
  data() {
    return {
      headers: [
        { title: 'Farm', value: 'farm', align: 'start' },
        { title: 'Line', value: 'line', align: 'start' },
        { title: 'MG', value: 'mg', align: 'start' },
        { title: 'Operator', value: 'operator', align: 'start' },
        { title: 'Tray', value: 'tray', align: 'start' },
        { title: 'Image #', value: 'imageNumber', align: 'center' },
        { title: 'Egg Count', value: 'eggCount', align: 'center' },
        { title: 'Avg Weight', value: 'avgWeight', align: 'end' },
        { title: 'Color Delta', value: 'colorDelta', align: 'end' },
        { title: 'Timestamp', value: 'timestamp', align: 'end' }
      ]
    }
  },
  
  computed: {
    ...mapState('capture', ['sessionData']),
    
    totalTrays() {
      return new Set(this.sessionData.map(d => d.tray)).size
    },
    
    totalEggs() {
      return this.sessionData.reduce((sum, d) => sum + (d.eggCount || 0), 0)
    },
    
    avgWeight() {
      if (this.sessionData.length === 0) return '0.0'
      const sum = this.sessionData.reduce((sum, d) => sum + (d.avgWeight || 0), 0)
      return (sum / this.sessionData.length).toFixed(1)
    },
    
    avgColorDelta() {
      if (this.sessionData.length === 0) return '0.00'
      const sum = this.sessionData.reduce((sum, d) => sum + (d.colorDelta || 0), 0)
      return (sum / this.sessionData.length).toFixed(2)
    }
  },
  
  methods: {
    exportData() {
      // Convert to CSV and download
      const csv = this.convertToCSV(this.sessionData)
      const blob = new Blob([csv], { type: 'text/csv' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `eggvision_capture_${new Date().toISOString()}.csv`
      link.click()
      window.URL.revokeObjectURL(url)
    },
    
    convertToCSV(data) {
      if (data.length === 0) return ''
      
      const headers = Object.keys(data[0]).join(',')
      const rows = data.map(row => 
        Object.values(row).map(val => 
          typeof val === 'string' && val.includes(',') ? `"${val}"` : val
        ).join(',')
      )
      
      return [headers, ...rows].join('\n')
    }
  }
}
</script>

<style scoped>
.text-grey {
  color: rgba(0, 0, 0, 0.6);
}
</style>
